import React, { useState, useEffect, useContext } from "react";
import PropTypes from 'prop-types';
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import moment from "moment";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import Box from '@mui/material/Box';
import { Button } from "@mui/material";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import NumberFormat from 'react-number-format';

const hoursMethods = [
    {
        value: 'Upload',
        label: 'File Upload',
    },
    {
        value: 'Integration',
        label: 'Integration',
    },
];

const censusMethods = [
    {
        value: 'CensusManagment',
        label: 'Census Management',
    },
    {
        value: 'EASE',
        label: 'EASE Integration',
    },
    {
        value: 'Upload',
        label: 'File Upload',
    },
    {
        value: 'Other',
        label: 'Other Integration',
    },
];

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={ref}
            displayType={'text'}
            thousandSeparator
            isNumericString
        />
    );
});

NumberFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const formatDate = (date) => date === null ? "" : moment(date).format("MM/DD/YYYY");

function CompanyDetailSettings({ refresh, groupType }) {
    const { companyId, feedback } = useContext(PrivateRoutesContext);
    const [fetchedData, setFetchedData] = useState([]);

    useEffect(() => {
        apiGet(apiUrls.getCompanyDetails(companyId)).then((response) => {
            setFetchedData(response.data);
        });
    }, [companyId]);

    const handleContactAXIM = () => {
        feedback.setType('Other Inquiries');
        feedback.setSubject('Company Details Update');
        feedback.setDoShow(true);
    }

    return (
        <React.Fragment>
            {/* fetchedData length check required to allow dropdown value to display after data load */}
            {Object.keys(fetchedData).length !== 0 ?
                <Container >
                    <Box component="form"
                        noValidate
                        autoComplete="off"
                    >
                        <Paper elevation={4} sx={{ display: "flex", p: 2, justifyContent: "space-between" }}>
                            {/* <Grid container spacing={2}> */}
                            <Typography variant="body2" >To make changes to this information please contact Align Admin</Typography>
                            {/* </Grid> */}
                            <Button
                                variant="outlined"
                                onClick={handleContactAXIM}
                                color="primary"
                            >
                                Contact Align Admin
                            </Button>
                        </Paper>
                        <Paper elevation={4}
                            sx={{
                                borderRadius: 2,
                                p: 4,
                                minWidth: 300,
                                my: 4
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" gutterBottom>
                                        Company Details
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Company name"
                                        fullWidth
                                        value={fetchedData.companyName}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="First name"
                                        fullWidth
                                        value={fetchedData.firstName}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Last name"
                                        fullWidth
                                        value={fetchedData.lastName}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Address line 1"
                                        fullWidth
                                        value={fetchedData.address1}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Address line 2"
                                        fullWidth
                                        value={fetchedData.address2}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <TextField
                                        label="City"
                                        fullWidth
                                        value={fetchedData.city}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <TextField
                                        label="State/Province/Region"
                                        fullWidth
                                        value={fetchedData.state}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextField
                                        label="Zip / Postal code"
                                        fullWidth
                                        value={fetchedData.zipcode}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <TextField
                                        label="Country"
                                        fullWidth
                                        value={fetchedData.country}
                                        variant="filled"
                                        InputProps={{ readOnly: true, }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </Grid>
                            </Grid>

                        </Paper>
                        {groupType === "FSG" ?
                            <Paper elevation={4}
                                sx={{
                                    p: 4,
                                    minWidth: 300,
                                    mb: 4
                                }}
                            >
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" gutterBottom>
                                            Configuration Details
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Company status"
                                            fullWidth
                                            value={fetchedData.status}
                                            variant="filled"
                                            InputProps={{ readOnly: true, }}
                                            InputLabelProps={{ shrink: true, }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Fringe Methodolgy"
                                            fullWidth
                                            value={fetchedData.fringeMethodology}
                                            variant="filled"
                                            InputProps={{ readOnly: true, }}
                                            InputLabelProps={{ shrink: true, }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            label="MSA Last Signed Date"
                                            fullWidth
                                            value={formatDate(fetchedData.msaLastSigned)}
                                            variant="filled"
                                            InputProps={{ readOnly: true, }}
                                            InputLabelProps={{ shrink: true, }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            select
                                            label="Hours Method"
                                            fullWidth
                                            value={fetchedData.hoursMethod ?? ''}
                                            variant="filled"
                                            InputProps={{ readOnly: true, }}
                                            InputLabelProps={{ shrink: true, }}
                                        >
                                            {hoursMethods.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            select
                                            label="Census Method"
                                            fullWidth
                                            value={fetchedData.censusMethod ?? ''}
                                            variant="filled"
                                            InputProps={{ readOnly: true, }}
                                            InputLabelProps={{ shrink: true, }}
                                        >
                                            {censusMethods.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Paper>
                        : null}
                    </Box>
                </Container>
                : ""}
        </React.Fragment>
    );
}

export default CompanyDetailSettings;
